module.exports = __webpack_public_path__ + "img/93856.3b1a280d.svg";